<template>
  <v-card color="grey lighten-4" flat>
    <v-btn v-if="showBackBtn" flat text elevation="0" @click="clickClose()">
      <v-icon>mdi-keyboard-backspace</v-icon>
      Back to events
    </v-btn>
    <v-toolbar height="35" :color="item.color" dark>
      <img
        v-if="item.icon"
        :src="item.icon"
        class="icon mr-2"
        width="30"
        height="30"
      />
      <v-toolbar-title v-html="item.name"></v-toolbar-title>
      <v-spacer v-if="!showBackBtn"></v-spacer>
      <v-btn v-if="!showBackBtn" icon @click="clickClose()">
        <v-icon>mdi-close-box</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div :class="item.color + '--text'" class="pa-0 mb-1 pull-right">
        {{ item.severity }} Severity
      </div>

      <div class="pa-0 mb-1">
        {{ item.categoryAndSubCategory }}
      </div>
      <h4 class="card-title pa-0 mb-1" v-html="item.name"></h4>
      <div class="pa-0 body caption my-1">{{ item.dateRange }}</div>
      <div class="pa-0 body caption mb-1" v-html="item.content"></div>

      <div class="pa-0 mb-1">
        <span class="application-heading">Impact Types:</span>
        <span class="ml-1">{{ item.impactCategoriesDisplay }}</span>
      </div>

      <div class="pa-0 mb-1" v-if="item.tagsDisplay">
        <span class="application-heading">Tags:</span>
        <span class="ml-1">{{ item.tagsDisplay }}</span>
      </div>
      <div class="pa-0 mb-1" v-if="item.locationPrecision">
        <span class="application-heading">Location precision:</span>
        <span class="ml-1">{{ item.locationPrecision }}</span>
      </div>
      <div class="pa-0 mb-1" v-if="item.source">
        <span class="application-heading">Source:</span>
        <span class="ml-1" v-html="item.source"></span>
      </div>
      <div class="pa-0 mb-1" v-if="item.perpetratorDisplay">
        <span class="application-heading">Perpetrator Type:</span>
        <span class="ml-1">{{ item.perpetratorDisplay }}</span>
      </div>
      <div class="pa-0 mb-1" v-if="item.perpetratorDetails">
        <span class="application-heading">Perpetrator Details:</span>
        <span class="ml-1 body caption" v-html="item.perpetratorDetails"></span>
      </div>

      <div v-if="item.countries" class="pa-0 hyp-item-location-list">
        <DetailsListItemLocations
          :countries="item.countries"
          theme="light"
          title="Countries"
        ></DetailsListItemLocations>
      </div>

      <div
        v-if="item.relatedCountries && item.relatedCountries.length > 0"
        class="pa-0 mt-1 mb-1 hyp-item-location-list"
      >
        <DetailsListItemLocations
          :countries="item.relatedCountries"
          theme="light"
          title="Related Countries"
        ></DetailsListItemLocations>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
const EMITTED_ACTIONS = {
  CLICK_CLOSE: "click-close",
};

export default {
  name: "CalendarEventsItem",
  components: {
    DetailsListItemLocations: () =>
      import("@/components/common/details/DetailsListItemLocations"),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    showBackBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
  },
};
</script>

<style scoped>
.body {
  max-height: 50vh;
  overflow-y: auto;
}
.hyp-item-location-list {
  font-size: 0.8em;
  line-height: 1.5em;
}
.icon {
  border-radius: 20px;
}
>>> .icon {
  filter: invert(0%) sepia(0%) saturate(0) hue-rotate(45deg);
  border: 1px solid gray;
  border-radius: 30px;
}
</style>
